/* ------------------------------------------------------------
   pdp-custom.js
   Shared script for Indidha PDP custom sections.
   Load once per page via:
     {{ 'pdp-custom.js' | asset_url | script_tag }}
------------------------------------------------------------ */

function indidhaInitTopSellerBadge() {
  var mediaContainer = document.querySelector('.product__media-wrapper, .product-media-container, .product__media-list');
  var badge = document.getElementById('brutalist-top-seller-badge');

  if (mediaContainer && badge) {
    mediaContainer.style.position = 'relative';
    badge.style.display = 'block';
    mediaContainer.appendChild(badge);
  }
}

function indidhaInitSizeGuide() {
  var modal = document.getElementById('custom-size-modal');
  var btn = document.getElementById('custom-size-guide-btn');
  var close = document.getElementById('custom-size-close');

  if (!modal || !btn || !close) return;

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    modal.style.display = 'block';
  });

  close.addEventListener('click', function () {
    modal.style.display = 'none';
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });
}

/* ---------- Price Block 1: floating scarcity badge ---------- */
/* Reads data-available off .indidha-premium instead of a Liquid
   {% if %}, since this file is a static asset, not Liquid-processed. */
function indidhaInitFloatingScarcity() {
  var wrapper = document.querySelector('.indidha-premium[data-available="true"]');
  if (!wrapper) return;

  var imageContainer = document.querySelector('.product__media-wrapper, .product__media-list, .product-gallery, .product-image-container');
  if (!imageContainer) return;

  var computedStyle = window.getComputedStyle(imageContainer);
  if (computedStyle.position === 'static') {
    imageContainer.style.position = 'relative';
  }

  var badge = document.createElement('div');
  badge.className = 'indidha-floating-badge';
  badge.innerHTML =
    '<div class="badge-number" id="floating-qty-number"></div>' +
    '<div class="badge-text">people<br>viewing<br>now</div>';
  imageContainer.appendChild(badge);

  var number = document.getElementById('floating-qty-number');
  if (!number) return;

  var qty = Math.floor(Math.random() * 11) + 4;
  number.textContent = qty;

  setInterval(function () {
    var shift = Math.floor(Math.random() * 3) - 1;
    qty = qty + shift;
    if (qty < 2) qty = 2;
    if (qty > 28) qty = 28;
    number.textContent = qty;
  }, Math.floor(Math.random() * 3000) + 3000);
}

/* ---------- Available Offers: copy-to-clipboard ---------- */
/* Delegated listener — works for any .offer-btn on the page,
   including every row rendered by pdp-available-offers.liquid. */
function indidhaInitOfferCopy() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.offer-btn');
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    var textSpan = btn.querySelector('.code-text');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        animateCopy(btn, textSpan);
      }).catch(function () {
        fallbackCopy(code, btn, textSpan);
      });
    } else {
      fallbackCopy(code, btn, textSpan);
    }
  });

  function fallbackCopy(code, btn, textSpan) {
    var textarea = document.createElement('textarea');
    textarea.value = code;
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      animateCopy(btn, textSpan);
    } catch (err) {
      console.warn('Copy failed');
    }
    document.body.removeChild(textarea);
  }

  function animateCopy(btn, textSpan) {
    btn.classList.add('copied');
    var originalText = textSpan.textContent;
    textSpan.textContent = 'COPIED';
    setTimeout(function () {
      btn.classList.remove('copied');
      textSpan.textContent = originalText;
    }, 2000);
  }
}

/* ---------- Price Block 1: delivery pincode checker ---------- */
function indidhaInitDeliveryChecker() {
  var pincodeInput = document.getElementById('pincode-input');
  var outputDiv = document.getElementById('delivery-date-output');
  var checkBtn = document.getElementById('delivery-check-btn');

  if (!pincodeInput || !outputDiv || !checkBtn) return;

  var transitSettings = {
    delhi_ncr: 2,
    metro: 3,
    tier_2: 5,
    rest_of_india: 7
  };

  var prefixes = {
    delhi_ncr: ['110', '121', '122', '201', '203'],
    metro: ['380', '382', '400', '410', '411', '412', '421', '500', '501', '502', '560', '600', '603', '700'],
    tier_2: [
      '141', '142', '160', '208', '209', '221', '226', '248', '282',
      '302', '303', '313', '360', '390', '391', '394', '395', '422',
      '440', '441', '452', '453', '462', '641', '751', '752', '781',
      '800', '801', '804', '831', '832', '834', '835'
    ]
  };

  function calculateDate(transitDays) {
    var date = new Date();
    var addedDays = 0;
    while (addedDays < transitDays) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) {
        addedDays++;
      }
    }
    return date.toLocaleDateString('en-IN', { weekday: 'short', month: 'short', day: 'numeric' }).toUpperCase();
  }

  function evaluatePincode() {
    var pincode = pincodeInput.value;
    if (pincode.length === 6) {
      var prefix = pincode.substring(0, 3);
      var transitDays = transitSettings.rest_of_india;

      if (prefixes.delhi_ncr.indexOf(prefix) !== -1) {
        transitDays = transitSettings.delhi_ncr;
      } else if (prefixes.metro.indexOf(prefix) !== -1) {
        transitDays = transitSettings.metro;
      } else if (prefixes.tier_2.indexOf(prefix) !== -1) {
        transitDays = transitSettings.tier_2;
      }

      outputDiv.innerHTML = '<span style="color: var(--theme-brand); font-weight: 700;">EXPECTED ARRIVAL:</span> <span style="color: var(--ind-ink); font-weight: 700;">' + calculateDate(transitDays) + '</span>';
    } else {
      outputDiv.innerText = 'See delivery time & options for your location';
    }
  }

  pincodeInput.addEventListener('input', function () {
    this.value = this.value.replace(/\D/g, '');
    if (this.value.length !== 6) {
      outputDiv.innerText = 'See delivery time & options for your location';
    }
  });

  checkBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (pincodeInput.value.length === 6) {
      evaluatePincode();
    } else {
      outputDiv.innerHTML = '<span style="color: #d9534f; font-weight: 500;">Please enter a valid 6-digit pin code.</span>';
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  indidhaInitTopSellerBadge();
  indidhaInitSizeGuide();
  indidhaInitFloatingScarcity();
  indidhaInitOfferCopy();
  indidhaInitDeliveryChecker();
});
